import axios from "axios";
import Config from "../../config";

const actionEditarIntegracao = (integracaoId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/integracoes/${integracaoId}/editar`,
        data
    });
};

export default actionEditarIntegracao;
